import { cn } from "@punchup/utils/cn";

export default function AlmostSoldOutBadge({
  className,
}: {
  className?: string;
}) {
  return (
    <div
      className={cn(
        "w-[132px] h-8 px-2 py-1 bg-[#fff2e7] rounded justify-center items-center gap-2.5 inline-flex",
        className
      )}
    >
      <div className="text-[#fe5e25] text-sm font-medium leading-normal">
        Almost sold out!
      </div>
    </div>
  );
}
